<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title
      :title="{ name: '项目交付管理', path: '/system/delivery/all' }"
    ></Title>

    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-input
              v-model="qparam.applyUserName"
              placeholder="申请人"
            ></el-input>
          </el-col>

          <el-col :span="5">
            <el-input
              v-model="qparam.projectName"
              placeholder="项目名称"
            ></el-input>
          </el-col>

          <el-col :span="9">
            <el-date-picker
              style=""
              v-model="applyTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col
            :span="5"
            style="float: right; margin-left: 10px; margin-top: 10px"
          >
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置
            </el-button>
            <el-button icon="el-icon-search" type="primary" @click="search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="projectName" label="项目名称">
          </el-table-column>
          <el-table-column width="220px" prop="deliveryType" label="交付类型" class-name="delivery-type-column">
            <template slot-scope="scope">
              <div class="tags-container">
                <!-- 分割 deliveryType 字符串 -->
                <div v-for="(type, index) in scope.row.deliveryType.split(',')" :key="index">
                  <!-- 遍历 deliveryTypeData，找到匹配的 typeId，显示相应的标签 -->
                  <div v-for="(row, i) in deliveryTypeData" :key="i">
                    <el-tag v-if="row.typeId == type" type="success" class="tag-item">
                      {{ row.typeName }}
                    </el-tag>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="200px" prop="applyTime" label="申请时间">
          </el-table-column>
          <el-table-column width="120px" prop="userName" label="申请人">
          </el-table-column>

          <el-table-column width="120px" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleDetail(scope.$index, scope.row)"
                >查看申请
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>
      <el-dialog
      title="项目交付信息"
      :visible.sync="projectShow"
      width="1200px"
      top="6vh">
      <ProjectDeliveryDetailsDialog 
       :key="uuid"
       :applyId="applyId"
       :applyServiceId="applyServiceId"
       :applyType="applyType"
       :role="1 || 4 || 8 ||13" ></ProjectDeliveryDetailsDialog>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "@/components/Title";
import {requestAllDeliveryApply, ownProjectDeliveryApply} from "@/api"
import {uuid,AesDecrypt} from "@/util";
import ProjectDeliveryDetailsDialog from "@/components/item/common/ProjectDeliveryDetailsDialog.vue";

export default {
  name: "AllDeliveryApply",
  components: {Title, ProjectDeliveryDetailsDialog},
  
  data() {
    return {
      uuid: "",
      hasPersonalRole: false,
      hasAllRole: false,
      applyId: "",
      applyServiceId: "",
      applyType: "",
      projectShow: false,
      applyTime: [],
      tableData: [],
      totalElements: 0,
      qparam: {
          current: 1,
          size: 10,
          applyUserName: "",
          startTime: "",
          endTime: "",
          projectName: ""
      },
      deliveryTypeData: [
        { typeId:1,typeName:"系统评估 "},
        { typeId:2,typeName:"方案评估 "},
        { typeId:3,typeName:"方案编制 "},
        { typeId:4,typeName:"密码应用 "},
        { typeId:5,typeName:"密码整改 "}
      ],
      user: {}
    }
  },
  computed: {
    ...mapState(["flowData"]),
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
    this.initTableData()
  },

  methods: {
    async initTableData() {
      this.qparam.startTime = this.applyTime[0]
      this.qparam.endTime = this.applyTime[1]
      const hasPersonalRole = this.user.roles.includes(8)
      const hasAllRole = this.user.roles.includes(1) || this.user.roles.includes(13)
      if (hasAllRole) {
        const res = await requestAllDeliveryApply(this.qparam);
        if (res.code === 200) {
          this.totalElements = res.total
          this.tableData = res.rows
          let data = this.tableData
          this.tableData = data
        } else {
          this.$message.error(res.msg)
        }
      } else if (hasPersonalRole) {
        const res = await ownProjectDeliveryApply(this.qparam);
        if (res.code === 200) {
          this.totalElements = res.total
          this.tableData = res.rows
          let data = this.tableData
          this.tableData = data
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData()
    },
    resetQparam() {
      this.applyTime = []
      if (!this.hasPersonalRole) {
        this.qparam.applyUserName = ""
      }
      this.qparam.projectName = ""
      this.initTableData()
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData()
    },
    async search() {
      this.qparam.current = 1
      this.qparam.size = 10
      await this.initTableData()
    },

    handleDetail(index, row) {
      this.projectShow = true
      this.applyId = row.applyId
      this.applyServiceId = row.applyServiceId,
      this.applyType = row.applyType
      this.uuid = uuid()
    },
  }
}
</script>

<style>
.paybackInfo {
  display: flex;
}
.paybackInfo-btn {
  margin-left: 12px;
  cursor: pointer;
  color: #409eff;
}

.low {
  /*  color: #f56c6c;*/
  color: red;
}
.middle {
  color: #e6a23c;
}
.height {
  /*  color: #5cb87a;*/
  color: green;
}
</style>

<style scoped>
.tags-container {
  display: flex;
  flex-wrap: wrap;
}

.tag-item {
  margin-right: 8px; /* tag 之间的间距 */
  margin-bottom: 8px; /* 换行时的间距 */
}

.delivery-type-column .el-tag {
  display: inline-block; /* 确保 tag 作为行内块元素显示 */
}
</style>
